module.exports = __webpack_public_path__ + "static/media/csa.06a280c8.svg";